<template>
  <div class="sds-view">
    <h1>学生直入计划 SDS</h1>
    <p class="subtitle">学习签证</p>
    
    <div class="content">
      <p>为具备一定英语能力并持有直接进入DLI就读的学生提供的一个简捷和快速的学习签证申请程序，通过SDS (Student Direct Stream) 计划，可以提交更少的资金证明文件以及获得更快的处理时间(通常在20天内获得学签)。</p>

      <h2>申请资格：</h2>
      <ul>
        <li>居留在有以下国家的合法居民：中国、印度、菲律宾、越南、巴西等14个国家</li>
        <li>持有专上教学学习机构(DLI)的录取通知书</li>
        <li>申请时居住在加拿大境外</li>
        <li>有证据证明已支付第一年学习的学费</li>
        <li>持有$10,000加元的担保投资证书（GIC）</li>
        <li>申请前进行体检（如果需要的话）</li>
        <li>在申请前获得无犯罪记录证明</li>
        <li>有最近的中学或专上学校成绩单</li>
        <li>IELTS成绩每科都在6.0或以上</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SDSView'
}
</script>

<style scoped>
.sds-view {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  font-size: 32px;
  margin-bottom: 10px;
}

.subtitle {
  color: #666;
  margin-bottom: 30px;
}

.content {
  max-width: 800px;
}

h2 {
  font-size: 24px;
  margin: 30px 0 20px;
}

ul {
  list-style-type: disc;
  padding-left: 20px;
  margin-bottom: 20px;
}

li {
  margin-bottom: 15px;
  line-height: 1.6;
}

p {
  margin-bottom: 20px;
  line-height: 1.6;
}
</style>